module.exports = __webpack_public_path__ + "img/plane.67ad0bc3.png";